import { usePermission } from "hooks/usePermission";
import React from "react";

const Bookings = () => {
  const { can } = usePermission();
  if (!can("bookings", "can_view")) return null;

  return <div className="page-content">Bookings</div>;
};

export default Bookings;
